import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import {Helmet} from 'react-helmet';
import { pdf as PDFRenderer }from '@react-pdf/renderer';

import Box from '../../components/common/Box';
import { tracksActions } from '../../data/actions/tracks';
import EntityCard from '../../components/common/EntityCard';
import EntityFilterName from '../../components/common/EntityFilterName';
import EntitiesList from '../../components/pages/home/EntitiesList';
import TerritoryStats from '../../components/common/Stats/Territory';
import DemographicsStats from '../../components/common/Stats/Demographics';
import DevicesStats from '../../components/common/Stats/Devices';
import SourcesStats from '../../components/common/Stats/Sources';
import VendorsWidget from '../../components/pages/home/VendorsWidget';
import SharePage from '../../components/pages/sharedPages/SharePage';
import SharedEntityCard from '../../components/common/SharedEntityCard';
import CSV from '../../helpers/CSVExport';
import { dspLogos } from "../../components/common/Stats/utils";
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import PDFDocument from '../../components/pages/tracks/PDF';
import Milestones from '../../components/pages/audience/Milestones';
import {Widget, WithWidgetManager} from '../../components/widgets/manager';
import RedirectToResults from '../../components/pages/result/RedirectToResults';

const downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');
const pdfSvg = require('!svg-inline-loader!../../../public/img/pdf.svg');

class TrackDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            title: ''
        };
        this.setParentEntity = this.setParentEntity.bind(this);
        this.exportToPdf = this.exportToPdf.bind(this);
    }

    componentDidMount() {
        const { match, dispatch } = this.props;
        this.setState({id: match.params.id});
    }

    componentWillReceiveProps(nextProps){
        const { match } = nextProps;
        if(match.params.id != this.state.id) {
            this.setState({id: null}, ()=>{
                this.setState({id: match.params.id});
            });
        }
        
    }

    setParentEntity(entity) {
        this.setState({
            title: entity.name_raw,
            titlePdf: `${entity.name_raw} (${entity.code}). Released on: ${entity.release_date}.`
        })
    }

    exportToCsv = () => {
      const multipleMode = this.state.id.includes(',');
      const {
        stats,
        products,
        tracks,
        playlists
      } = this.props;

      let data = [
        { top_platforms: stats.vendor.data },
        { top_playlists: playlists.top },
        { sources: stats.sources.table },
        { demographics: stats.demographics.table },
        { territories: stats.territory.table },
        { devices: stats.devices.table }
      ];
      
      if(multipleMode)
          data.unshift({ top_tracks: tracks.top })
      else
          data.unshift({ top_products: products.top });
      
      const filename = CSV.CSVHeader('track_details', this.state.id, this.props.filter.global);

      CSV.CSVBulkExport(data, filename);

    }
    
    getPdfData() {
        const { id } = this.props.match.params,
            reportTitle = 'Track Details',
            { playlists, products, stats } = this.props;
            
        const imageIDs = [
              'track_details_vendors',
              'track_details_demographics',
              'track_details_sources',
              'track_details_devices',
        ];
        let images = {};
        for (let imageID of imageIDs){
            let image = document.getElementById(imageID);
            if(image)
                images[imageID] = image.toDataURL("image/jpeg,1.0"); 
        }
        const tables = {
            products: products.top,
            playlists: playlists.top,
            territories: stats.territory.table
        }
        return { reportTitle, images, tables, globalFilter: this.props.filter.global, entity: this.state.titlePdf };
    }
    
    exportToPdf() {
        const data = PDFRenderer(<PDFDocument data={this.getPdfData()} />);
        data.toBlob()
        .then(blob=>{
            const fileURL = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = "track_details.pdf";
            link.click();
        });
    }
    

    render() {
        if(!this.state.id)
            return null;
        
        const multipleMode = this.state.id.includes(',');
        let metaTitle = this.state.title ? `${this.state.title} - ` : '';
        metaTitle += 'Details';

        const { sharedMode, widgetProps } = this.props;
        
        let milestones = this.props.milestones.entities["tracks"];
        if(milestones && milestones.tableItems) 
            milestones = milestones.tableItems;
        else
            milestones = [];
        return <RedirectToResults entity="tracks" id={this.state.id} />
        return <div className="track-details">
                <div className="">
                    <div className="row">
                        {!multipleMode && <div className="col-xs-12 pd-0 default">
                            <div className="share-page-title-holder">
                                <MatchMediaWrapper breakpoint={768} isMobile={false}>
                                    <h2>Track Details</h2>
                                    {!sharedMode && <SharePage entity="tracks" id={this.state.id} exportToCsv={this.exportToCsv} exportToPdf={this.exportToPdf} />}
                                </MatchMediaWrapper>
                            </div>
                            {!sharedMode && <EntityCard entity="tracks" id={this.state.id} onResult={this.setParentEntity} showLink={true} />}
                            {sharedMode && <SharedEntityCard entity="tracks" id={this.state.id} onResult={this.setParentEntity} />}
                        </div>}
                        {multipleMode && <div className="col-xs-12 pd-0 default">
                            <h2>Track Group Details</h2>
                            <EntityFilterName entity="tracks" ids={this.state.id} />
                        </div>}                        
                    </div>
                    {sharedMode && <div className="row download-page">
                        <span>Export</span>
                        <a key="download" title="Download entire page" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
                        <span>PDF</span>
                        <a key="pdf" title="Download PDF" onClick={this.exportToPdf} className="download-link" dangerouslySetInnerHTML={{__html: pdfSvg}} />
                    </div>}

                    <div className="row">
                        <div className="col-xs-12 pd-0 default">
                            <Widget widgetID="vendors" widgetProps={widgetProps}>
                                <VendorsWidget entity="tracks" id={this.state.id} parentEntityTitle={this.state.title}  shadowChartProps={{id: 'track_details_vendors', shadowChartWidth: 800, shadowChartHeight: 400}} />
                            </Widget>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 pd-0 default">
                        {!multipleMode && <Widget widgetID="top_products" widgetProps={widgetProps}>
                            <EntitiesList trends={true} title="Top Products" entity="products" parentEntity="tracks" parentEntityIDs={this.state.id} parentEntityTitle={this.state.title} externalLinks={!sharedMode} milestones={milestones} />    
                            </Widget>}
                        {multipleMode && <Widget widgetID="top_tracks" widgetProps={widgetProps}>
                            <EntitiesList trends={true} title="Top Tracks" entity="tracks" parentEntity="tracks" parentEntityIDs={this.state.id} parentEntityTitle={this.state.title} externalLinks={!sharedMode} milestones={milestones} />
                            </Widget>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 pd-0 default">
                        <Widget widgetID="top_playlists" widgetProps={widgetProps}>
                            <EntitiesList trends={true} title="Top Playlists" entity="playlists" parentEntity="tracks" parentEntityIDs={this.state.id} parentEntityTitle={this.state.title} showPlaylistAnalisysLink={true} externalLinks={!sharedMode} /></Widget>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-xs-12 pd-0 default territory-details">
                            <Widget widgetID="sources" widgetProps={widgetProps}>
                                <SourcesStats entity="tracks" ids={this.state.id} parentEntityTitle={this.state.title} chartType={dspLogos.sources.id}  shadowChartProps={{id: 'track_details_sources', shadowChartWidth: 400, shadowChartHeight: 300}} />
                            </Widget>
                        </div>

                        <div className="col-lg-6 col-xs-12 pd-0 default">
                            <Widget widgetID="demographics" widgetProps={widgetProps}>
                                <DemographicsStats entity="tracks" ids={this.state.id} parentEntityTitle={this.state.title} chartType={dspLogos.age.id} shadowChartProps={{id: 'track_details_demographics', shadowChartWidth: 800, shadowChartHeight: 400}} />
                            </Widget>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-xs-12 pd-0 default territory-details">
                            <Widget widgetID="territories" widgetProps={widgetProps}>
                                <TerritoryStats entity="tracks" ids={this.state.id} parentEntityTitle={this.state.title} chartType={dspLogos.territories.id} />
                            </Widget>
                        </div>
                        <div className="col-lg-6 col-xs-12 pd-0 default">
                            <Widget widgetID="devices" widgetProps={widgetProps}>
                                <DevicesStats entity="tracks" ids={this.state.id} parentEntityTitle={this.state.title} chartType={dspLogos.devices.id} shadowChartProps={{id: 'track_details_devices', shadowChartWidth: 400, shadowChartHeight: 300}}  />
                            </Widget>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 pd-0 default">
                            <Milestones entity="tracks" id={this.state.id} sharedMode={sharedMode} />
                        </div>
                    </div>
                    
                    <Helmet>
                        <title>{metaTitle}</title>
                    </Helmet>

                </div>
            </div>;
    }
}

function mapStateToProps(state) {
    return {
        tracks: state.tracks,
        filter: state.filter,
        stats: state.stats,
        products: state.products,
        tracks: state.tracks,
        playlists: state.playlists,
        milestones: state.milestones
    }
}

export default connect(mapStateToProps)(WithWidgetManager(TrackDetails, 'track_details'))